import {Brick, registerBrick} from 'olympe';

/**
 * A brick parses json
 */
export default class JSONParse extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} json
     * @param {function(*)} setObject
     */
    update($, [json], [setObject]) {
        const parsedJson = JSON.parse(json);
        setObject(parsedJson);
    }
}

registerBrick('018626bd992e7832c1bc', JSONParse);
